module.exports = __webpack_public_path__ + "static/media/room-image2.9cac93bb.png";